module.exports = __webpack_public_path__ + "media/images/award-badges-zh-my-242bc1b590cc7f06f2725ebbf7541378.svg";